import { common } from "../../../../config/style-configs/common";

export const styles = {
  style: {
    flex: 1
  },
  errorMessage: common.containerErrorMessage
};
